import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home.vue";
import Login from "../views/Login/login.vue";
import Login1 from "../views/Login/login11.vue";
import unfind from "../views/404.vue";
import { routesData , setNavTabData } from "@/utils/permission";
import store from "../store/index";
Vue.use(VueRouter);

export const routes = [
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/login1",
    name: "login1",
    component: Login1,
  },
  {
    path: "/",
    name: "home",
    component: Home,
    redirect: "/custom",
    children: [
      // {
      //   path: "/custom",
      //   name: "custom",
      //   component: () => import(`../views/custom/custom-main.vue`),
      // },
      // {
      //   path: "/sellchance",
      //   name: "sellchance",
      //   component: () => import(`../views/sellChance/sellChance-main.vue`),
      // },
      // {
      //   path: "/contract",
      //   name: "contract",
      //   component: () => import(`../views/contract/contract-main.vue`),
      // },
      // {
      //   path: "/contractback",
      //   name: "contractback",
      //   component: () => import(`../views/contractBack/contractBack-main.vue`),
      // },
      {
        path: "/constapply",
        name: "constapply",
        component: () => import(`../views/constApply/constApply-main.vue`),
      },
      // {
      //   path: "/housecontract",
      //   name: "housecontract",
      //   component: () => import(`../views/houseContract/house-contract.vue`),
      // },
      // {
      //   path: "/housecollection",
      //   name: "housecollection",
      //   component: () =>
      //     import(`../views/houseCollection/house-collection.vue`),
      // },
      // {
      //   path: "/openbill",
      //   name: "openbill",
      //   component: () => import(`../views/openBill/openBill-main.vue`),
      // },
      // {
      //   path: "/data",
      //   name: "data",
      //   component: () => import(`../views/dataList/data-main.vue`),
      // },
      {
        path: "/channel",
        name: "channel",
        component: () => import(`../views/channel/channel-main.vue`),
      },
      // {
      //   path: "/message",
      //   name: "message",
      //   component: () => import(`../views/message/system-message.vue`),
      // },
      // {
      //   path: "/notice",
      //   name: "notice",
      //   component: () => import(`../views/message/system-notice.vue`),
      // },
      // {
      //   path: "/todolist",
      //   name: "todolist",
      //   component: () => import(`../views/message/todo-list.vue`),
      // },
      // {
      //   path: "/terrace/member",
      //   name: "terrace/member",
      //   component: () => import(`../views/terrace/member-terrace.vue`),
      // },
      // {
      //   path: "/terrace/depart",
      //   name: "terrace/depart",
      //   component: () => import(`../views/terrace/depart-terrace.vue`),
      // },
      // {
      //   path: "/terrace/role",
      //   name: "terrace/role",
      //   component: () => import(`../views/terrace/role-terrace.vue`),
      // },
      // {
      //   path: "/terrace/power",
      //   name: "terrace/power",
      //   component: () => import(`../views/terrace/power-terrace.vue`),
      // },
      // {
      //   path: "/terrace/personal",
      //   name: "terrace/personal",
      //   component: () => import(`../views/terrace/personal-terrace.vue`),
      // },
      // {
      //   path: "/system/companyset",
      //   name: "system/companyset",
      //   component: () => import(`../views/system/company-set.vue`),
      // },
      // {
      //   path: "/systemdate",
      //   name: "systemdate",
      //   component: () => import(`../views/system/system-main.vue`),
      // },
      {
        path: "/system/params",
        name: "system/params",
        component: () => import(`../views/system/params-manage.vue`),
      },
      {
        path: "/system/contractTem",
        name: "/system/contractTem",
        component: () => import(`../views/system/contract.vue`),
      },

      //宣传系统地址
      {
        path: "/manage/binhang",
        name: "/manage/binhang",
        component: () => import(`../views/binhang-manage/binhang-manage.vue`),
      },
      //   // 自定义查询
      // {
      //   path: "/CustomQuery",
      //   name: "/CustomQuery",
      //   component: () => import(`../views/CustomQuery/index.vue`),
      // },
        //标签组
      {
        path: "/taggroup",
        name: "/taggroup",
        component: () => import(`../views/taggroup/index.vue`),
      },
        //关系图谱
      {
        path: '/RelationalGraph',
        name:'/RelationalGraph',
        component: () => import(`../views/RelationalGraph/index.vue`),
      },
      {
        path: "/manage/merchant",
        name: "/manage/merchant",
        component: () => import(`../views/merchant-manage/merchant-manage.vue`),
      },
      {
        path: "/qifu/carousel",
        name: "/qifu/carousel",
        component: () => import(`../views/qifu-manage/qifu-carousel.vue`),
      },
      {
        path: "/qifu/service",
        name: "/qifu/service",
        component: () => import(`../views/qifu-manage/qifu-service.vue`),
      },
      {
        path: "/tj/douyin",
        name: "/tj/douyin",
        component: () => import(`../views/tongji/douyin.vue`),
      },
      {
        path: "/info/activity",
        name: "/info/activity",
        component: () => import(`../views/info-manage/activity.vue`),
      },
      {
        path: "/info/review",
        name: "/info/review",
        component: () => import(`../views/info-manage/review.vue`),
      },
      {
        path: "/info/lesson",
        name: "/info/lesson",
        component: () => import(`../views/info-manage/lesson.vue`),
      },
      {
        path: "/info/about",
        name: "/info/about",
        component: () => import(`../views/info-manage/about.vue`),
      },
      {
        path: "/info/question",
        name: "/info/question",
        component: () => import(`../views/info-manage/question.vue`),
      },
      {
        path: "/info/message",
        name: "/info/message",
        component: () => import(`../views/info-manage/message.vue`),
      },
        //积分兑换V2
      {
        path: "/score/coupon",
        name: "/score/coupon",
        component: () => import(`../views/score-manage/coupon.vue`),
        // component: () => import(`../views/points/index.vue`),
      },
      {
        path: "/points/",
        name: "/points/",
        // component: () => import(`../views/score-manage/coupon.vue`),
        component: () => import(`../views/points/index.vue`),
      },
      {
        path: "/score/situation",
        name: "/score/situation",
        component: () => import(`../views/score-manage/situation.vue`),
      },
      {
        path: "/system/mumber",
        name: "/system/mumber",
        component: () => import(`../views/system-manage/mumber.vue`),
      },
      {
        path: "/system/history",
        name: "/system/history",
        component: () => import(`../views/system-manage/history.vue`),
      },
        //皮肤管理
      {
        path: '/system/skin',
        name: '/system/skin',
        component: () => import(`../views/system-manage/skin.vue`),
      },
      {
        path: "/person/customer",
        name: "/person/customer",
        component: () => import(`../views/person-manage/customer-list.vue`),
      },
      {
        path: "/person/customerActive",
        name: "/person/customerActive",
        component: () => import(`../views/person-manage/customer-active.vue`),
      },
      {
        path: "/person/customerService",
        name: "/person/customerService",
        component: () =>
          import(`../views/person-manage/customer-service-list.vue`),
      },
      {
        path: "/person/feedback",
        name: "/person/feedback",
        component: () => import(`../views/person-manage/feedback-list.vue`),
      },
      // {
      //   path: "/specially",
      //   name: "specially",
      //   component: () => import(`../views/specially/specially-main.vue`),
      // },
      // {
      //   path: "/person/customerActive",
      //   name: "/person/customerActive",
      //   component: () => import(`../views/person-manage/customer-active.vue`),
      // },
      // {
      // 	path: "/person/share",
      // 	name: "/person/share",
      // 	component: () => import(`../views/person-manage/share-list.vue`),
      // },
      // {
      // 	path: "/person/photoshare",
      // 	name: "/person/photoshare",
      // 	component: () => import(`../views/person-manage/photoshare.vue`),
      // },
      // {
      // 	path: "/personal",
      // 	name: "/personal",
      // 	component: () => import(`../views/personal-center/personal.vue`),
      // },
      {
        path: "/info/userinfo",
        name: "/info/userinfo",
        component: () => import(`../views/info-manage/userinfo.vue`),
      },
      {
        path: "/SourceMaterial",
        nmae:"SourceMaterial",
        component:()=>import(`../views/SourceMaterial/index.vue`)
      },
      {
        path: "/BizCommLib",
        nmae:"BizCommLib",
        component:()=>import(`../views/BizCommLib/BizCommLib.vue`)
      },
      {
        path: "/activities",
        nmae:"activities",
        component:()=>import(`../views/activities/index.vue`)
      },
      {
        path: "/material",
        nmae:"material",
        component:()=>import(`../views/material/index.vue`)
      },
        //文章发布
      {
        path: "/ArticleRelease",
        name: "/ArticleRelease",
        component: () => import(`../views/ArticleRelease/index.vue`),
      },
      {
        path: "/binhang/business",
        name: "/binhang/business",
        component: () => import(`../views/official/business.vue`),
      },
      {
        path: "/binhang/cases",
        name: "/binhang/cases",
        component: () => import(`../views/official/cases.vue`),
      },
      {
        path: "/binhang/service",
        name: "/binhang/service",
        component: () => import(`../views/official/service.vue`),
      },
      {
        path: "/binhang/alliance",
        name: "/binhang/alliance",
        component: () => import(`../views/official/alliance.vue`),
      },
      {
        path: "/binhang/about",
        name: "/binhang/about",
        component: () => import(`../views/official/about.vue`),
      },
      // {
      //   path: "/field/list",
      //   name: "field",
      //   component: () => import(`../views/field/field-list.vue`),
      // },
      // {
      //   path: "/field/process",
      //   name: "process",
      //   component: () => import(`../views/field/process-manage.vue`),
      // },
      // {
      //   path: "/bill/billdetail",
      //   name: "bill",
      //   component: () => import(`../views/bill/bill-detail.vue`),
      // },
      // {
      //   path: "/bill/personaldetail",
      //   name: "billpersonal",
      //   component: () => import(`../views/bill/personal-detail.vue`),
      // },
      // {
      //   path: "/house",
      //   name: "house",
      //   component: () => import(`../views/house/house-main.vue`),
      // },
      // {
      //   path: "/houselease",
      //   name: "houselease",
      //   component: () => import(`../views/houselease/houselease-main.vue`),
      // },
      {
        path: "/projmgmt/index",
        name: "projmgmt-index",
        component: () => import(`../views/projmgmt/index.vue`),
      },
      {
        path: "/projmgmt/myprojmgmt",
        name: "projmgmt-myprojmgmt",
        component: () => import(`../views/projmgmt/myprojmgmt.vue`),
      },
      {
        path: "/projmgmt/mytask",
        name: "projmgmt-mytask",
        component: () => import(`../views/projmgmt/mytask.vue`),
      },
      {
        path: "/projmgmt/projmgmtcount",
        name: "projmgmt-count",
        component: () => import(`../views/projmgmt/product-count.vue`),
      },
      // {
      //   path: "/params",
      //   name: "params",
      //   component: () => import(`../views/params/params-main.vue`),
      // },





      {
        path: "/system/log",
        name: "log",
        component: () => import(`../views/system/system-log.vue`),
      },
      {
        path: "/params/property",
        name: "property",
        component: () => import(`../views/system/params-property.vue`),
      },
      //政策
      {
        path: "/policy",
        name: "policy",
        component: () => import(`../views/policy/policy-main.vue`),
      },
      // //客户微信
      // {
      //   path: "/wechat",
      //   name: "wechat",
      //   component: () =>
      //     import(`../views/custom-wechat/custom-wechat-main.vue`),
      // },
      // //政策
      // {
      //   path: "/wechat-group",
      //   name: "wechat-group",
      //   component: () => import(`../views/custom-group/custom-group-main.vue`),
      // },
      // //线索公海
      // {
      //   path: "/clue",
      //   name: "clue",
      //   component: () => import(`../views/clue/clue-main.vue`),
      // },

      // {
      // 	path: '/projmgmt/projmgmtcount',
      // 	name:'projmgmt-count',
      // 	component: () => import(`../views/projmgmt/product-count.vue`),
      // },

      // {
      //   path: '/system/companyset',
      //   name: 'companyset',
      //   component: companyset
      // },
      // {
      //   path: '',
      //   name: 'home',
      // },
      // {
      //   path: '/sellchance',
      //   name: 'sellchance',
      //   component: sellchance
      // },
      // {
      //   path: '/houseContract',
      //   name: 'houseContract',
      //   component: houseContract
      // },
      // {
      //   path: '/houseCollection',
      //   name: 'houseCollection',
      //   component: houseCollection
      // },
      // {
      //   path: '/terrace/depart',
      //   name: 'depart',
      //   component: depart
      // },
      // {
      //   path: '/terrace/member',
      //   name: 'member',
      //   component: member
      // },
      // {
      //   path: '/terrace/role',
      //   name: 'role',
      //   component: role
      // },
      // {
      //   path: '/terrace/power',
      //   name: 'power',
      //   component: power
      // },
      // {
      //   path: '/terrace/personal',
      //   name: 'personal',
      //   component: personal
      // },
      // {
      //   path: '/custom',
      //   name: 'custom',
      //   component: custom
      // },
      // {
      //   path: '/contract',
      //   name: 'contract',
      //   component: contract,
      // },
      // {
      //   path: '/contractback',
      //   name: 'contractback',
      //   component: contractback
      // },
      // {
      //   path: '/constapply',
      //   name: 'constapply',
      //   component: constapply
      // },
      // {
      //   path: '/openbill',
      //   name: 'openbill',
      //   component: openbill
      // },
      // {
      //   path: '/todolist',
      //   name: 'todolist',
      //   component: todolist
      // },
      // {
      //   path: '/message',
      //   name: 'message',
      //   component: message
      // },
      // {
      //   path: '/notice',
      //   name: 'notice',
      //   component: notice
      // },

      // {
      // 	path: '/system/params',
      // 	name: 'system/params',
      // 	component: () => import(`../views/system/params-manage.vue`),
      // },
      // //新人自助
      // {
      //   path: "/selfservice",
      //   name: "selfservice",
      //   component: () => import(`../views/selfservice/selfservice.vue`),
      // },
      //开发中 防止左侧菜单选中重复
      {
        path: "/newcomer",
        name: "newcomer",
        component: () => import(`../views/newcomer/newcomer-main.vue`),
      },
      //开发中 防止左侧菜单选中重复
      // {
      //   path: "/managereport",
      //   name: "managereport",
      //   component: () => import(`../views/manageReport/manageReport-main.vue`),
      // },
      // {
      //   path: "/followRecord",
      //   name: "followRecord",
      //   component: () => import(`../views/custom-follow/custom-follow-main.vue`),
      // },
      // {
      //   path: "/field/template",
      //   name: "template",
      //   component: () => import(`../views/field/template-main.vue`),
      // },
      {
        path: "/developing2",
        name: "developing2",
        component: () => import(`../views/newcomer/newcomer-main.vue`),
      },
      {
        path: "/developing3",
        name: "developing3",
        component: () => import(`../views/newcomer/newcomer-main.vue`),
      },
      {
        path: "/developing4",
        name: "developing4",
        component: () => import(`../views/newcomer/newcomer-main.vue`),
      },
      {
        path: "/developing5",
        name: "developing5",
        component: () => import(`../views/newcomer/newcomer-main.vue`),
      },
      {
        path: "/developing6",
        name: "developing6",
        component: () => import(`../views/newcomer/newcomer-main.vue`),
      },
      {
        path: "/developing7",
        name: "developing7",
        component: () => import(`../views/newcomer/newcomer-main.vue`),
      },
      {
        path: "/developing8",
        name: "developing8",
        component: () => import(`../views/newcomer/newcomer-main.vue`),
      },
      {
        path: "/developing9",
        name: "developing9",
        component: () => import(`../views/newcomer/newcomer-main.vue`),
      },
      {
        path: "/adminExp",
        name: "adminExp",
        component: () => import(`../views/adminExp/adminExp.vue`),
      },
      {
        path: "/costOut",
        name: "costOut",
        component: () => import(`../views/costOut/costOut.vue`),
      },
      {
        path: "/download-record",
        name: "download-record",
        component: () => import(`../views/system/download-record.vue`),
      },
      {
        path: "/flexible-employ",
        name: "flexible-employ",
        component: () => import(`../views/flexible-employ/index.vue`),
      },
      {
        path: "/mapping-manage",
        name: "mapping-manage",
        component: () => import(`../views/system/mapping-manage.vue`),
      },
      // {
      //   path: "/park-report",
      //   name: "park-report",
      //   component: () => import(`../views/data-report/park-report.vue`),
      // },
    ],
  },
  {
    path: "/404",
    name: "404",
    component: unfind,
  },
  {
    path: "/view/:id",  // :id 表示路径参数
    name: "view",
    component: () => import(`../views/activities/view.vue`),
  },
  {
    path: "/downfile",
    name: "downfile",
    component: () => import(`../views/knowHouse/downfile.vue`),
  },
  {
    path: "/paperpreview",
    name: "paperpreview",
    component: () => import(`../views/projmgmt/paper-preview.vue`),
  },
  {
    path: "/modelperview",
    name: "modelperview",
    component: () => import(`../views/field/process-model-perview.vue`),
  },
  {
    path: "/wxlogin",
    name: "wxlogin",
    component: () => import(`../views/jumpPage/wxlogin.vue`),
  },
];
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((error) => error);
};

const router = new VueRouter({
  routes,
});
router.reloadRouter = function () {
  router.matcher = new VueRouter({
    routes,
  }).matcher;
};
let hasRoles = true;
// router.beforeEach(async (to, from, next) => {
//   // 默认设置统一门户标题（同步执行）
//     document.title = '滨航集团统一门户';
//   // 处理/view路由的特殊标题
//   if (/^\/view\/\d+$/.test(to.path)) {
//     document.title = '加载中...';
//   }
//
//   if (to.matched.length === 0 && hasRoles == false) {
//     next();
//   } else {
//     // 要去登录界面,直接放行
//     if (
//       to.path === "/login" ||
//       to.path === "/wxlogin" ||
//       to.path === "/downfile" ||
//       /^\/view\/\d+$/.test(to.path)
//     ) {
//       next();
//     } else {
//       const token = localStorage.getItem("token");
//       if (!token) {
//         next("/login");
//       } else {
//         if (hasRoles) {
//           await routesData(store.state.userpower);
//           hasRoles = false;
//           next({ ...to, replace: true });
//         } else {
//           next();
//         }
//
//         next();
//       }
//     }
//   }
// });
//
// //beforeEach --- 组件销毁过早 会导致生命周期混乱
// router.afterEach((to, from,)=>{
//     //使用time 判断是否更新缓存
//     let time = !!to.query.q ?  Number(to.query.q) : new Date().getTime();
//     store.commit('setViewKey',time);
//     const exclude = ['/login','/wxlogin','/downfile']
//     if(exclude.includes(to.path) || /^\/view\/\d+$/.test(to.path)){
//
//     }else{
//       setNavTabData(to,time)
//     }
// })


// 设置 favicon 的函数
function setFavicon(url) {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = url;
}


router.beforeEach(async (to, from, next) => {

  const isViewPage = /^\/view\/\d+$/.test(to.path);

  if (isViewPage) {
    document.title = '加载中...';
    // 设置透明图标（1x1 png）
    setFavicon('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mO8WQ8AAmMBzNOpyYoAAAAASUVORK5CYII=');
  } else {
    document.title = '滨航集团统一门户';
    // 恢复你项目原本的 favicon 地址（根据实际路径修改）
    setFavicon('/favicon.ico');
  }

  if (to.matched.length === 0 && hasRoles === false) {
    return next();
  }

  const whiteList = ["/login", "/wxlogin", "/downfile"];
  if (whiteList.includes(to.path) || /^\/view\/\d+$/.test(to.path)) {
    return next();
  }

  const token = localStorage.getItem("token");
  if (!token) {
    return next("/login");
  }

  if (hasRoles) {
    await routesData(store.state.userpower);
    hasRoles = false;
    return next({ ...to, replace: true });
  }

  next();
});

router.afterEach((to, from) => {
  const time = to.query.q ? Number(to.query.q) : Date.now();
  store.commit('setViewKey', time);

  const exclude = ['/login', '/wxlogin', '/downfile'];
  if (!exclude.includes(to.path) && !/^\/view\/\d+$/.test(to.path)) {
    setNavTabData(to, time);
  }
});


export default router;
